import React from 'react';
import { BsFillPlayBtnFill, BsPauseBtnFill } from 'react-icons/bs';
import { FaCircleStop } from 'react-icons/fa6';

interface TimerDisplayProps {
    timeLeft: number;
    sessionStarted: boolean;
    sessionPaused: boolean;
    sessionCompleted: boolean;
    onStart: () => void;
    onPause: () => void;
    onResume: () => void;
    onEnd: () => void;
    className?: string;
    children?: React.ReactNode;
}

const formatTime = (seconds: number) => {
    const totalSeconds = Math.round(seconds);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const secs = totalSeconds % 60;

    if (hours > 0) {
        return `${hours}:${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
    }
    return `${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
};

const TimerDisplay: React.FC<TimerDisplayProps> = ({
    timeLeft,
    sessionStarted,
    sessionPaused,
    sessionCompleted,
    onStart,
    onPause,
    onResume,
    onEnd,
    className = "",
    children
}) => {
    return (
        <div className={`flex flex-col w-full h-full ${className}`}>
            <div className="p-6 sm:p-8 flex flex-col items-center justify-center flex-shrink-0 relative border-b border-gray-200/60">
                <div className="text-7xl sm:text-8xl lg:text-[10rem] font-medium text-gray-900 font-mono tracking-tighter mb-12">
                    {formatTime(timeLeft)}
                </div>

                <div className="flex gap-4">
                    {!sessionStarted ? (
                        <button
                            onClick={onStart}
                            className="px-8 py-3 bg-orange-600 hover:bg-orange-700 text-white rounded-xl font-medium transition-all shadow-sm flex items-center gap-2"
                        >
                            <BsFillPlayBtnFill className="text-xl" /> Start Session
                        </button>
                    ) : sessionPaused ? (
                        <button
                            onClick={onResume}
                            className="px-8 py-3 bg-orange-600 hover:bg-orange-700 text-white rounded-xl font-medium transition-all shadow-sm flex items-center gap-2"
                        >
                            <BsFillPlayBtnFill className="text-xl" /> Resume
                        </button>
                    ) : (
                        <button
                            onClick={onPause}
                            className="px-8 py-3 bg-white border border-orange-200 text-orange-600 hover:bg-orange-50 rounded-xl font-medium transition-all flex items-center gap-2"
                        >
                            <BsPauseBtnFill className="text-xl" /> Pause
                        </button>
                    )}

                    {sessionStarted && !sessionCompleted && (
                        <button
                            onClick={onEnd}
                            className="px-8 py-3 bg-white border border-red-200 text-red-500 hover:bg-red-50 rounded-xl font-medium transition-all flex items-center gap-2"
                        >
                            <FaCircleStop className="text-xl text-red-500" /> End
                        </button>
                    )}
                </div>
            </div>
            {children}
        </div>
    );
};

export default TimerDisplay;
